import { useRef, useState, useCallback } from "react";
import { MoveHorizontal } from "lucide-react";

export default function BeforeAfterSlider({ before, after, testid, beforeLabel = "Pôvodná", afterLabel = "Návrh" }) {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const dragging = useRef(false);

  const move = useCallback((clientX) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const p = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, p)));
  }, []);

  const onDown = (e) => { dragging.current = true; move(e.touches ? e.touches[0].clientX : e.clientX); };
  const onMove = (e) => { if (dragging.current) move(e.touches ? e.touches[0].clientX : e.clientX); };
  const onUp = () => { dragging.current = false; };

  return (
    <div
      ref={ref}
      data-testid={testid}
      className="relative w-full aspect-[4/3] overflow-hidden select-none cursor-ew-resize bg-ink"
      onMouseDown={onDown} onMouseMove={onMove} onMouseUp={onUp} onMouseLeave={onUp}
      onTouchStart={onDown} onTouchMove={onMove} onTouchEnd={onUp}
    >
      <img src={after} alt={afterLabel} className="absolute inset-0 w-full h-full object-cover pointer-events-none" draggable={false} />
      <div className="absolute inset-0 overflow-hidden pointer-events-none" style={{ width: `${pos}%` }}>
        <img src={before} alt={beforeLabel} className="absolute inset-0 h-full object-cover max-w-none" style={{ width: ref.current ? ref.current.offsetWidth : "100%" }} draggable={false} />
      </div>

      <span className="absolute top-2 left-2 text-[10px] uppercase tracking-widest bg-black/70 text-white px-2 py-1 pointer-events-none">{beforeLabel}</span>
      <span className="absolute top-2 right-2 text-[10px] uppercase tracking-widest bg-gold/90 text-ink px-2 py-1 pointer-events-none">{afterLabel}</span>

      <div className="absolute top-0 bottom-0 w-0.5 bg-gold pointer-events-none" style={{ left: `${pos}%` }}>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-gold text-ink flex items-center justify-center shadow-lg">
          <MoveHorizontal className="w-4 h-4" />
        </div>
      </div>
    </div>
  );
}
